<template>
  <div id="app">
    <comp-room
      :sdkAppId="Number(sdkAppId)"
      :secretKey="secretKey"
      :userId="userId"
      :roomId="Number(roomId)"
      :cameraId="cameraId"
      :microphoneId="microphoneId"
      v-bind="$attrs"
      v-on="$listeners"
      ref="adduser"
    ></comp-room>
  </div>
</template>

<script>
import compRoom from "@/components/comp-room.vue";
// import { clearUrlParam } from '@/utils/utils';

export default {
  name: "App",
  components: {
    compRoom
  },
  data() {
    return {
      sdkAppId: 1600119414,
      secretKey:
        "8820dddf0dbd426f40db84a9de6d5d730d9a593a120b9cd1bfbeb1d3947e5aae",
      userId: "web_" + parseInt(Math.random() * 100000000),
      roomId: parseInt(Math.random() * 100000, 10),
      cameraId: "",
      microphoneId: ""
    };
  },
  methods: {},
  mounted() {
    // clearUrlParam();
  }
};
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  padding-bottom: 40px;
  .content {
    width: 80%;
    margin: 0 auto;
    max-width: 1320px;
    .alert {
      padding-top: 20px;
      font-size: 16px !important;
    }
    &.content-mobile {
      width: 100%;
      padding: 0 16px 20px;
    }
    .label {
      margin: 14px 0 6px;
      text-align: left;
      font-weight: bold;
    }
    .param-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      div {
        width: calc((100% - 20px) / 2);
        margin-bottom: 10px;
      }
      div:nth-last-child(2),
      div:nth-last-child(1) {
        margin-bottom: 0;
      }
      &.param-container-mobile {
        div {
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
